import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import DropdownButtonToggle from '../../shared/styledComponents/DropdownButtonToggle';

export default InjectedStyledComponent(DropdownButtonToggle, 'iconDropdown', ['buttonToggle']);